import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.PricingFrequencyEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    pricingFrequencyEnumList: { items: data, total },
  } = await sdk.getListPricingFrequencyEnum(
    filterSortPage({ sort, pagination })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { pricingFrequencyEnum: data } = await sdk.getOnePricingFrequencyEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { pricingFrequencyEnumMany: data } =
    await sdk.getManyPricingFrequencyEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const pricingFrequencyEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
